import React from 'react'
import { Route } from 'react-router-dom'

import RoleContainer from './container'

const AdminRole = () => (
  <React.Fragment>
    <Route path="/:workspaceToken/settings/roles/" component={RoleContainer} />
  </React.Fragment>
)

export default AdminRole



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Roles/index.js